module.exports = __webpack_public_path__ + "assets/images/animations/enqsta-animation.png?f256ce95";